import { Box, CircularProgress } from '@mui/material';
import QuestionCard from '../components/QuestionCard';
import { QuizNotification } from '../components/QuizNotification';
import { QuizStyles } from '../styles/QuizStyles';
import { QuestionCardStyles } from '../styles/QuestionCardStyles';
import { CommonStyles } from '../styles/CommonStyles';
import { useQuizNotification } from '../hooks/useQuizNotification';
import {
  QuizProgressBar,
  QuizHeader,
  QuizNavigation,
  NextRoundModal,
  QuizCongratulations,
} from '../components/quiz';
import { useQuiz } from '../hooks/useQuiz';

const Quiz = () => {
  const { showNotification, hideNotification } = useQuizNotification();
  const {
    // State
    currIndex,
    isConfettiExploding,
    isNextRoundModalOpen,
    loading,

    // Data
    userQuestions,

    // Computed values
    isCurrentQuestionBookmarked,
    hasUserSeenAllQuestions,
    isAllQuestionsCompleted,
    isCurrentQuestionAnswered,
    score,
    totalQuestions,
    isCompleted,

    // Event handlers
    handleBookmarkToggle,
    handleResetProgress,
    handleNavigateToDashboard,
    handleNavigateToHistory,
    handleCloseCompleteQuizModal,
    handleCloseNextRoundModal,
    handleCreateNewQuiz,
    handleQuestionSelection,
    handlePreviousQuestion,
    handleNextQuestion,
    handleQuestionClick,
  } = useQuiz();

  if (loading) {
    return (
      <Box sx={CommonStyles.loadingContainer}>
        <CircularProgress size={70} />
      </Box>
    );
  }

  if (!userQuestions?.length) {
    if (hasUserSeenAllQuestions) {
      return (
        <QuizCongratulations
          isConfettiExploding={isConfettiExploding}
          onResetProgress={handleResetProgress}
        />
      );
    }
    return <Box sx={QuizStyles.noContent}>No questions found</Box>;
  }

  return (
    <Box sx={{ ...QuestionCardStyles.root }}>
      {showNotification && (
        <QuizNotification
          onClose={() => hideNotification(false)}
          onDontShowAgain={hideNotification}
        />
      )}
      <Box sx={{ ...QuestionCardStyles.container, position: 'relative' }}>
        <QuizHeader
          isBookmarked={isCurrentQuestionBookmarked}
          onBookmarkToggle={handleBookmarkToggle}
          isCompleted={isCompleted}
        />

        <QuizProgressBar
          userQuestions={userQuestions}
          currentIndex={currIndex}
          onQuestionClick={handleQuestionClick}
        />

        <NextRoundModal
          open={isNextRoundModalOpen}
          onClose={handleCloseNextRoundModal}
          onCreateNewQuiz={handleCreateNewQuiz}
          onGoToDashboard={handleNavigateToDashboard}
        />

        <QuestionCard
          key={userQuestions[currIndex].question.id}
          userQuestion={userQuestions[currIndex]}
          index={currIndex}
          onSelectedOption={handleQuestionSelection}
          disabled={isCompleted}
        />

        <QuizNavigation
          currentIndex={currIndex}
          totalQuestions={totalQuestions}
          onPrevious={handlePreviousQuestion}
          onNext={handleNextQuestion}
          isCurrentQuestionAnswered={isCurrentQuestionAnswered}
          isAllQuestionsCompleted={isAllQuestionsCompleted}
        />
      </Box>
    </Box>
  );
};

export default Quiz;
